module.exports = __webpack_public_path__ + "612d8fd54d320f3fdf5e0bc71de06838.png";